module.exports = __webpack_public_path__ + "img/certificate.832a91b7.png";